// src/components/NavBar.js

import React, { useState, useEffect, useRef } from 'react';
import AppBar from '@mui/material/AppBar';
import Toolbar from '@mui/material/Toolbar';
import Typography from '@mui/material/Typography';
import IconButton from '@mui/material/IconButton';
import Avatar from '@mui/material/Avatar';
import CalendarTodayIcon from '@mui/icons-material/CalendarToday';
import { useNavigate } from 'react-router-dom';
import { useSelector, useDispatch } from 'react-redux';
import Select from '@mui/material/Select';
import MenuItem from '@mui/material/MenuItem';
import { updateTL } from '../../redux/slices/userSlice'; // Adjust with the actual path to your userSlice file
import { Box, Button, Tooltip } from '@mui/material';
import NotificationCard from './notification'; // Adjust with the actual path to your NotificationCard component
import TinkerLabListAPIs from '../../utilities/api/TinkersLab/TinkerLabListAPIs';
import CreateTL from './CreateTL';
import { ImageBaseURL } from '../../utilities/api/axios';
import WebSocketService from '../../utilities/api/IMS/websocketService'; // Import your WebSocketService
import DropdownArrow from './icons/DropdownArrow';
import AlertNotificationIcon from './icons/AlertNotificationIcon';
import CalendarIcon from './icons/CalendarIcon';
import MessagesIcon from './icons/MessagesIcon';

const NavBar = () => {
  const [notifi, setNotifi] = useState(false);
  const [notifications, setNotifications] = useState([]);
  const [openNotifications, setOpenNotifications] = useState(false);
  const [tinkerLabs, setTinkerLabs] = useState([]);
  const [openCreateTL, setOpenCreateTL] = useState(false);
  const [messageCount, setMessageCount] = useState(0); // New state for message count
  const { access, user } = useSelector(state => state.user.user); // Adjusted access to user state
  const dispatch = useDispatch();
  const navigate = useNavigate();

  // console.log('user in navbar: ', user);

  const userAvatarUrl = user.profile_pic
    ? `${ImageBaseURL}${user.profile_pic}`
    : '';
  // console.log('userAvatarUrl: ', userAvatarUrl);

  // Fetch Tinker Labs
  useEffect(() => {
    const fetchTinkerLabs = async () => {
      try {
        const labs = await TinkerLabListAPIs.TinkerLabsListGet();
        const sortedLabList = labs.sort((a, b) => a.id - b.id);
        setTinkerLabs(sortedLabList);
      } catch (error) {
        console.error('Error fetching Tinker Labs data:', error);
      }
    };
    fetchTinkerLabs();
  }, [openCreateTL]);

  // GLOBAL WebSocket connection
  //   useEffect(() => {
  //     // 1) Request Notification permission if not granted
  //     if (Notification.permission !== 'granted') {
  //       Notification.requestPermission().then(permission => {
  //         if (permission !== 'granted') {
  //           console.warn('Permission for notifications was denied.');
  //         }
  //       });
  //     }

  //     // 2) Connect as soon as user info is available
  //     GlobalWebSocketService.connect(access, user.username, user.username);
  //     socketRef.current = GlobalWebSocketService;

  //     // 3) Register a message callback
  //     GlobalWebSocketService.onMessage((messageData) => {
  //       console.log("Global WebSocket message received:", messageData);

  //       if (messageData && messageData.message && messageData.sender) {
  //         // Only show a notification if it's NOT from the currently active chat user
  //         if (messageData.sender !== activeChatUser) {
  //           const newNotification = {
  //             avatar: "https://www.example.com/avatar.jpg",
  //             message: `Message from ${messageData.sender}: ${messageData.message}`,
  //             time: new Date().toLocaleTimeString() + " • Today",
  //           };
  //           setNotifications(prev => [...prev, newNotification]);

  //           // Optionally, dispatch to Redux if you want all incoming messages stored
  //           // dispatch(addMessage({ ... }));

  //           // Show a browser Notification
  //           showNotification(newNotification);
  //         }
  //       }
  //     });

  //     // 4) IMPORTANT: No disconnect here—this is a global service
  //     //    It should remain open until user logs out.
  //     return () => {
  //       // If you want to close on logout, do it in your logout logic, not on unmount here.
  //     };
  //   }, [access, user.username, activeChatUser, dispatch]);

  // Show a desktop notification
  //   const showNotification = (notification) => {
  //     if (Notification.permission === 'granted') {
  //       new Notification('New Message', {
  //         body: notification.message,
  //         icon: notification.avatar,
  //       });
  //     }
  //   };

  // useEffect(() => {
  //     // WebSocket connection for receiving messages
  //     const connectWebSocket = () => {
  //         WebSocketService.connect(access, user.username); // Use user.username for connection
  const handleTLChange = event => {
    const selectedTLName = event.target.value;
    // Find the selected lab to get its ID
    const selectedLab = tinkerLabs.find(lab => lab.name === selectedTLName);
    
    if (selectedLab) {
      dispatch(updateTL({ 
        TL: selectedTLName,
        TL_id: selectedLab.id,
        TL_obj: { id: selectedLab.id, name: selectedLab.name }
      }));
      console.log('NavBar - TL Changed:', { name: selectedTLName, id: selectedLab.id });
    } else {
      dispatch(updateTL({ TL: selectedTLName }));
    }
  };

  const handleCreateTLOpen = () => {
    setOpenCreateTL(true);
  };

  const handleCreateTLClose = () => {
    setOpenCreateTL(false);
  };

  const handleNavigation = route => {
    navigate(`/${route}`); // Replace '/calendar' with your desired path
  };

  //     connectWebSocket();

  {
    user?.TL_name === 'MBF Admin' && (
      <Button
        variant="contained"
        color="primary"
        onClick={handleCreateTLOpen}
        sx={{ marginRight: '27px' }}
      >
        Create TL
      </Button>
    );
  }

  {
    user.TL_name !== 'MBF Admin' && (
      <IconButton
        color="inherit"
        sx={{ marginRight: '27px' }}
        onClick={handleNavigation}
      >
        <CalendarTodayIcon />
      </IconButton>
    );
  }

  // const handleProfile = () => {
  //     navigate('/profile'); // Replace '/profile' with your desired path
  // };

  // Determine whether to show the profile icon
  const showProfileIcon =
    (user.is_org_admin && user.TL_name === 'MBF Admin') || !user.is_org_admin;

  return (
    <>
      <AppBar
        sx={{
          boxShadow: '0px 4px 12px 0px #0000001A',
          zIndex: 1100,
        }}
        position="static"
        color="inherit"
        elevation={1}
      >
        <Toolbar>
          <Typography
            variant="h6"
            component="div"
            sx={{
              color: '#007BFF',
              marginLeft: { xs: '0.5%', sm: '0.75%', md: '1%' },
              isolation: 'isolate',
              position: 'relative',
              zIndex: 1,
              fontSize: { xs: '1rem', sm: '1.15rem', md: '1.25rem' },
            }}
          >
            {user?.is_org_admin ? (
              <Select
                IconComponent={DropdownArrow}
                sx={{
                  color: '#007BFF',
                  fontSize: { xs: 'large', sm: 'large', md: 'x-large' },
                  '& .MuiOutlinedInput-notchedOutline': {
                    border: 'none',
                  },
                  '&:hover .MuiOutlinedInput-notchedOutline': {
                    border: 'none',
                  },
                  '&.Mui-focused .MuiOutlinedInput-notchedOutline': {
                    border: 'none',
                  },
                }}
                MenuProps={{
                  PaperProps: {
                    sx: {
                      zIndex: 1200,
                    },
                  },
                  disablePortal: true,
                  disableScrollLock: true,
                  BackdropProps: {
                    invisible: true,
                  },
                }}
                value={user.TL_name || ''}
                onChange={handleTLChange}
                displayEmpty
                inputProps={{ 'aria-label': 'Select TL' }}
              >
                {tinkerLabs.map(lab => (
                  <MenuItem key={lab.id} value={lab.name}>
                    {lab.name === 'MBF Admin' ? 'MBF Admin' : lab.name}
                  </MenuItem>
                ))}
              </Select>
            ) : (
              user?.TL_name || ''
            )}
          </Typography>

          {/* Spacer to push right-side elements to the right */}
          <Box sx={{ flexGrow: 1 }} />

          {user?.TL_name === 'MBF Admin' && (
            <Button
              variant="contained"
              onClick={handleCreateTLOpen}
              sx={{
                marginRight: { xs: '10px', sm: '15px', md: '27px' },
                backgroundColor: '#007BFF',
                borderRadius: '12px',
                fontSize: { xs: '0.75rem', sm: '0.85rem', md: '0.875rem' },
                padding: { xs: '4px 8px', sm: '6px 12px', md: '6px 16px' },
              }}
            >
              Create TL
            </Button>
          )}

          <Tooltip title="Notifications">
            <IconButton
              color="inherit"
              sx={{ marginRight: { xs: '5px', sm: '8px', md: '10px' } }}
              onClick={() => {
                setOpenNotifications(!openNotifications);
                if (notifi && !openNotifications) {
                  setNotifi(false);
                }
              }}
            >
              <AlertNotificationIcon notifi={notifi} />
            </IconButton>
          </Tooltip>

          {/* {user.TL_name !== "Org-Admin" && ( */}
          <Tooltip title="Calendar">
            <IconButton
              color="inherit"
              sx={{ marginRight: { xs: '5px', sm: '8px', md: '10px' } }}
              onClick={() => handleNavigation('calendar')}
            >
              <CalendarIcon />
            </IconButton>
          </Tooltip>
          {/* )} */}

          <Tooltip title="Messages">
            <IconButton
              color="inherit"
              sx={{ marginRight: { xs: '5px', sm: '8px', md: '10px' } }}
              onClick={() => handleNavigation('messages')}
            >
              <MessagesIcon />
            </IconButton>
          </Tooltip>

          {/* Conditional rendering of profile icon */}
          {showProfileIcon && (
            <IconButton
              color="inherit"
              sx={{ marginRight: { xs: '5px', sm: '8px', md: '10px' } }}
              onClick={() => handleNavigation('profile')}
            >
              <Avatar
                alt="User Avatar"
                src={userAvatarUrl}
                sx={{
                  width: { xs: 28, sm: 32, md: 36 },
                  height: { xs: 28, sm: 32, md: 36 },
                }}
              />
            </IconButton>
          )}
        </Toolbar>
      </AppBar>
      {openNotifications && (
        <NotificationCard
          notifications={notifications}
          closeNotification={setOpenNotifications}
        />
      )}
      <CreateTL open={openCreateTL} handleClose={handleCreateTLClose} />
    </>
  );
};

export default NavBar;
